import BannerComp from "../BannerComp";
import GridComponent from "../GridComponent";
import PartnerSliderComp from "../PartnerSliderComp";
import ServicesSection from "../ServicesSection";
import ServiceWhyChooseSection from "../ServiceWhyChooseSection";
import { SpecialCardSection } from "../SpecialCard";
import { specialties } from "../../data/specialties";

export default function ServicePageTemplate({
  banner,
  grid,
  services,
  faq,
  specialtiesContent,
}) {
  return (
    <>
      <BannerComp
        heading={banner.heading}
        paragraph={banner.paragraph}
        btnText="Let's Connect"
        btnLink="/contact-us"
        BannerBgImg="/pages-banner.webp"
        BannerColImg={banner.image}
        form={false}
      />
      <PartnerSliderComp />
      <GridComponent
        kicker={grid.kicker}
        heading={grid.heading}
        description={grid.description}
        metrics={grid.metrics}
        panelEyebrow={grid.panelEyebrow}
        panelHeading={grid.panelHeading}
        assurances={grid.assurances}
      />
      <ServicesSection
        heading={services.heading}
        description={services.description}
        buttonLabel="Let's Connect"
        buttonLink="/contact-us"
        items={services.items}
      />
      <ServiceWhyChooseSection
        imageSrc={faq.image}
        imageAlt={faq.imageAlt}
        title={faq.title}
        description={faq.description}
        btnText={faq.btnText}
        question={faq.question}
        answer={faq.answer}
      />
      <SpecialCardSection
        items={specialties}
        variant="list"
        eyebrow={specialtiesContent.eyebrow}
        heading={specialtiesContent.heading}
        description={specialtiesContent.description}
      />
    </>
  );
}
